import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import banner_home1 from "@/assets/banner_home1.png";
import { useTranslation } from "@/translations/TranslationContext";
import "./Banner.css";

function BannerHome() {
  const { t } = useTranslation();
  const [isMobile, setIsMobile] = useState(false);

  // Check if the screen is mobile size
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    // Initial check
    checkMobile();
    
    // Add event listener for window resize
    window.addEventListener('resize', checkMobile);
    
    // Cleanup
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.2,
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { duration: 0.4 }
    }
  };

  const imageVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { duration: 0.5, ease: "easeOut" }
    }
  };

  const highlightStyle = {
    fontWeight: "bold",
    display: "inline-block"
  };

  return (
    <div id="hero-section" className="banner homebanner mb150_75" style={{ position: 'relative', zIndex: 5, marginTop: isMobile ? '60px' : '0' }}>
      <div className="container">
        <div className="row">
          <motion.div 
            className="col-lg-6 col-md-12"
            initial="hidden"
            animate="visible"
            variants={containerVariants}
          >
            <div className="hombancont">
              {/* No animation for the chip */}
              <span className="chips" style={{ backgroundColor: '#ABBD23', color: '#fff' }}>
                {t.hero.tagline}
              </span>
              
              <motion.h1 
                variants={itemVariants}
                style={{ color: '#fff', marginTop: '15px', marginBottom: '20px' }}
              >
                <motion.span
                  style={highlightStyle}
                >
                  {t.hero.title.highlight1}
                </motion.span>
                {t.hero.title.part2}
                <motion.span
                  style={highlightStyle}
                >
                  {t.hero.title.highlight2}
                </motion.span>
              </motion.h1>
              
              <motion.p 
                className="text14"
                variants={itemVariants}
                style={{ color: '#fff', textTransform: 'uppercase', marginBottom: '20px' }}
              >
                {t.hero.consultation}
              </motion.p>
              
              <motion.div 
                variants={itemVariants}
                style={{ width: '100%', textAlign: isMobile ? 'center' : 'left' }}
              >
                <a
                  href="/contact"
                  className="btn btn-primary"
                  style={{ 
                    display: 'inline-block',
                    minWidth: '200px',
                    textAlign: 'center'
                  }}
                >
                  {t.hero.contactUs}
                </a>
              </motion.div>
            </div>
          </motion.div>
          {!isMobile && (
            <div className="col-lg-6"style={{ marginTop: '75px' }}>
              <motion.img 
                src={banner_home1} 
                alt="banner_home1"
                initial="hidden"
                animate="visible"
                variants={imageVariants}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default BannerHome;
